<template>
  <v-container class="help-section-wrapper" fluid>
    <v-row>
      <v-col class="col-12 col-md-7 pa-md-0" offset-md="1">
        <h2 v-html="data.title"></h2>
        <h5 v-html="data.subtitle"></h5>
      </v-col>
      <v-col class="col-12 col-md-10 pa-md-0" offset-md="1">
        <ul class="help-list-wrapper row">
          <li
            v-for="(help, i) in data.helpList"
            :key="i"
            class="col col-12 col-md-6"
          >
            <div class="content">
              <v-img
                contain
                width="249px"
                :src="require('@/assets/images/homepage/' + help.image)"
              />
              <h3 v-html="help.title"></h3>
              <p v-html="help.text"></p>
              <a
                class="button"
                :href="help.button.url"
                :target="help.button.external_url === true ? '_blank' : '_self'"
                ><v-icon>{{ mdiArrowRight }}</v-icon></a
              >
            </div>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiArrowRight } from '@mdi/js';

export default {
  name: 'HelpSection',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    mdiArrowRight,
  }),
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.help-section-wrapper
  padding-top: 100px
  padding-bottom: 100px
  h2
    display: inline-block
    font-family: 'metropolissemi_bold'
    font-weight: 600
    font-size: 32px
    line-height: 1.8
    color: #003036
    border-bottom: 4px solid #26D07C
    text-shadow: 0.5px 0.5px #003036
    margin-bottom: 35px
    ::v-deep
      span
        font-family: 'metropolisregular'
        font-weight: 400
  h5
    font-family: 'metropolisregular'
    font-style: normal
    font-weight: 400
    font-size: 18px
    line-height: 1.4
    color: #72737A
    margin-bottom: 60px
    ::v-deep
      span
        font-family: 'metropolisbold'
        font-weight: 700
  .help-list-wrapper
    padding: 0
    margin: 0
    list-style-type: none
    li
      padding: 0
      &:nth-child(odd)
        padding-right: 15px
      &:nth-child(even)
        padding-left: 15px
      &:nth-child(2),
      &:nth-child(4)
        padding-top: 70px
      &:nth-child(1),
      &:nth-child(4)
        .content
          background: #DEF7E5
          h3,
          p
            color: #003036
            ::v-deep
              a
                color: #003036
          .button
            border: 1px solid #003036
            .v-icon
              color: #003036
            &:hover
              background: #003036
              .v-icon
                color: #ffffff
      &:nth-child(2),
      &:nth-child(3)
        .content
          background: #003036
          h3,
          p
            color: #ffffff
          .button
            border: 1px solid #ffffff
            .v-icon
              color: #ffffff
            &:hover
              background: #ffffff
              .v-icon
                color: #003036
      .content
        min-height: 610px
        border-radius: 16px
        padding: 60px 50px 25px
        .v-image
          margin-bottom: 80px
        h3,
        p
          margin-bottom: 35px
        h3
          font-family: 'metropolissemi_bold'
          font-weight: 600
          font-size: 32px
          line-height: 1.4
        p
          font-family: 'metropolisregular'
          font-style: normal
          font-weight: 400
          font-size: 18px
          line-height: 1.4
          ::v-deep
            span
              font-family: 'metropolisbold'
              font-weight: 700
            a
              color: #fff
        .button
          position: relative
          display: inline-block
          font-family: 'metropolisbold'
          font-style: normal
          font-weight: 700
          font-size: 16px
          line-height: 24px
          text-transform: uppercase
          align-items: center
          padding: 10px
          max-width: 46px
          max-height: 46px
          border-radius: 40px
          outline: none
          text-decoration: none
          transition: all 0.3s ease-in-out
          &:hover,
          .v-icon
            transition: all 0.3s ease-in-out
  @media screen and (max-width: 959px)
    padding-top: 50px
    padding-bottom: 50px
    h2
      font-size: 24px
    h5
      font-size: 16px
      margin-bottom: 45px
    .help-list-wrapper
      li
        margin-bottom: 25px
        padding: 0 !important
        .content
          padding: 40px 30px 30px
          h3
            font-size: 24px
          p
            font-size: 16px
</style>
